// extracted by css-extract-rspack-plugin
export default {"root":"BSd9Lk","heading":"w7aZJ9","description":"nNqEQN","appliesTo":"jLoTIY"};